<template>
    <form ref="form" :action="action" :method="method" @submit.prevent="onSubmit">
        <div class="field">
            <div class="control">
                <add-map
                        :address="address"
                        :latitude.sync="form.latitude"
                        :longitude.sync="form.longitude"
                ></add-map>
            </div>
        </div>
        <!--<div class="field mt-4">
            <div class="control">
                <input type="text" v-model="form.area" class="input bg-transparent" name="area" :placeholder="t('area')" required>
            </div>
        </div>
        <div class="field mt-4">
            <div class="control">
                <input type="text" v-model="form.street" class="input bg-transparent" name="street" :placeholder="t('street')" required>
            </div>
        </div>-->
        <div class="field mt-4">
            <div class="control">
                <textarea class="form-textarea block w-full border-secondary-300 rounded-lg bg-transparent text-center" rows="5" v-model="form.note" :placeholder="t('address_details')" required></textarea>
            </div>
        </div>
        <div class="text-center mt-4">
            <button class="bg-secondary-300 text-white px-10 py-2 font-semibold rounded-md " type="submit">حفظ</button>
        </div>
    </form>
</template>

<script>
    import axios from 'axios';
    import arabic from 'vee-validate/dist/locale/ar';
    import { Validator , mapFields} from 'vee-validate';
    import AddMap from './AddMap'
    import trans from './translation/user.json';
    export default {
        name: "AddAddress",
        components : {
            AddMap
        },
        props: {
            address : {
                type :Object,
                required :false,
            },
            action: {
                type: String,
                required: true
            },
            method : {
                type : String,
                required: true
            },
            sitelocale:{
                type: String,
                required: true
            },
        },
        data() {
            return {
                submitting: false,
                success: false,
                form : {
                    note: this.address  ? this.address.note : '',
                    //area: this.address ? this.address.area :'',
                    //street: this.address ? this.address.street :'',
                    latitude: this.address ? this.address.latitude :'',
                    longitude: this.address ? this.address.longitude :''
                },
            }
        },
        mounted() {
            this.$translate.setLang(this.sitelocale);
        },
        locales: trans,
        created() {
            this.$validator.localize('ar', {
                messages: arabic.messages,
                attributes: trans.ar,
                custom:trans.ar.custom
            });
            this.$validator.localize('en', {
                custom:trans.en.custom
            });

            Validator.localize(this.sitelocale);
        },
        methods: {
            onSubmit(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.submitting = true;
                        let action = '';
                        if (this.address != null) {
                            action = `/api${this.action}/${this.address.id}/update_address`;
                        } else {
                            action = this.action;
                        }
                        console.log(action);
                        axios.post(action, this.form)
                        .then( response => {
                            console.log(response);
                            this.$toasted.success(response.data.success);
                            this.success = true;
                            setTimeout(function() {
                                window.location.reload();
                            }, 1000);
                        })
                        .catch(error => {
                            console.log(error);
                            let toaster = this.$toasted;
                            $.each(error.response.data.errors, function(key, value) {
                                toaster.error(value.message);
                            });
                            this.success = false;

                        })
                        .then(()=>{
                            this.submitting = false;
                            setTimeout(()=>{
                                this.success = false;
                            }, 3500);
                        });
                    }

                });

            },
            clearInputs(){
                let inputs = document.querySelectorAll(".form-block .form-element");
                $.each(inputs, function(key, value) {
                    console.log(value.tagName);
                    if(value.tagName  == 'INPUT' || value.tagName  == 'TEXTAREA'){
                        value.value ="";
                    }else{
                        value.innerHTML="";
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/front/components/AddAddress.vue